import React from "react";
import { Navbar, Nav } from "react-bootstrap";

import "./Header.css";

import logo from "../../asset/images/logo.png";

class Header extends React.Component {
  render() {
    return (
      <Navbar id="navbar" collapseOnSelect expand="lg" variant="dark">
        <Navbar.Brand className="nav_brand">
          <img alt="" className="nav_img" src={ logo } />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="nav">
            <Nav.Link id={this.props.pageName === 'index' ? 'nav_button_select' : 'nav_button'} href="/">首页</Nav.Link>
            <Nav.Link id={this.props.pageName === 'product' ? 'nav_button_select' : 'nav_button'} href='/product'>产品服务</Nav.Link>
            <Nav.Link id={this.props.pageName === 'news' ? 'nav_button_select' : 'nav_button'} href="/news">新闻资讯</Nav.Link>
            <Nav.Link id={this.props.pageName === 'successCase' ? 'nav_button_select' : 'nav_button'} href="/case">成功案例</Nav.Link>
            <Nav.Link id={this.props.pageName === 'about' ? 'nav_button_select' : 'nav_button'} href="/about">关于我们</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}

export default Header
